module.exports = __webpack_public_path__ + "static/media/assignment.a7315060.png";